/* tslint:disable */
/* eslint-disable */
/**
 * RaidSIMP OpenAPI Spec
 * Manage your raid teams, enhanced with data from the Blizzard API.
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AdminConfigDto,
    AdminConfigDtoFromJSON,
    AdminConfigDtoToJSON,
} from '../models';

export interface AdminControllerUpdateConfigRequest {
    adminConfigDto: AdminConfigDto;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Get all configurable settings.
     */
    async adminControllerGetConfigRaw(): Promise<runtime.ApiResponse<AdminConfigDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminConfigDtoFromJSON(jsonValue));
    }

    /**
     * Get all configurable settings.
     */
    async adminControllerGetConfig(): Promise<AdminConfigDto> {
        const response = await this.adminControllerGetConfigRaw();
        return await response.value();
    }

    /**
     * Get the default values of all configurable settings.
     */
    async adminControllerGetDefaultConfigRaw(): Promise<runtime.ApiResponse<AdminConfigDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/config/defaults`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminConfigDtoFromJSON(jsonValue));
    }

    /**
     * Get the default values of all configurable settings.
     */
    async adminControllerGetDefaultConfig(): Promise<AdminConfigDto> {
        const response = await this.adminControllerGetDefaultConfigRaw();
        return await response.value();
    }

    /**
     * Whether the currently logged in user may use the admin panel.
     */
    async adminControllerIsAdminRaw(): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/is-admin`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Whether the currently logged in user may use the admin panel.
     */
    async adminControllerIsAdmin(): Promise<boolean> {
        const response = await this.adminControllerIsAdminRaw();
        return await response.value();
    }

    /**
     * Replace all configurable settings.
     */
    async adminControllerUpdateConfigRaw(requestParameters: AdminControllerUpdateConfigRequest): Promise<runtime.ApiResponse<AdminConfigDto>> {
        if (requestParameters.adminConfigDto === null || requestParameters.adminConfigDto === undefined) {
            throw new runtime.RequiredError('adminConfigDto','Required parameter requestParameters.adminConfigDto was null or undefined when calling adminControllerUpdateConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/config`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdminConfigDtoToJSON(requestParameters.adminConfigDto),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminConfigDtoFromJSON(jsonValue));
    }

    /**
     * Replace all configurable settings.
     */
    async adminControllerUpdateConfig(requestParameters: AdminControllerUpdateConfigRequest): Promise<AdminConfigDto> {
        const response = await this.adminControllerUpdateConfigRaw(requestParameters);
        return await response.value();
    }

}
